import 'bootstrap';
import $ from 'jquery';
import { awaitLoad } from '../page-modules/page-modules';

type ModalOptions = {
    href: string;
    size: string;
    modalclass: string;
    customEvents: string;

}

export default (elm:HTMLElement, cb:Function = null) => {
    if (!elm) return;

    var loadURL = $(elm).attr('href') as string || $(elm).data('href') as string;
    var modalSize = $(elm).data('size');
    var modalClass = $(elm).data('modalclass');

    var options:ModalOptions ={
        href:"",
        size:"",
        modalclass:"",
        customEvents: "",
    };

    options.href = loadURL;

    if (modalSize !== 'undefined') {
        options.size = modalSize;
    }

    if (modalClass !== 'undefined') {
        options.modalclass = modalClass;
    }

    if (typeof $(elm).data('custom-events') !== 'undefined') {
        var customEventsArray = $(elm).data('custom-events').split(',');

        options.customEvents = customEventsArray;
    }
    
    var modal = $('#global_modal');
    var modalDialog = $('.modal-dialog', modal);
    var modalContent = $('.modal-body', modal);

    // Firing custom events
    if (typeof options.customEvents !== 'undefined') {
        if (Array.isArray(options.customEvents)) {
            for (var i = 0; i <= options.customEvents.length; i++) {
                var eventToFire = options.customEvents[i] + '';
                $(document).trigger(eventToFire);
            }
        } else {
            $(document).trigger(options.customEvents);
        }
    }

    // Store the default loading text in data so we can reuse it
    if (!modal.data('loadingtext')) {
        modal.data('loadingtext', modalContent.html());
    }

    // Try and destroy all Modals before  emptying it
    //$('.owl-carousel', modalContent).trigger('destroy.owl.carousel');
    modal.on('hidden.bs.modal', () => {
        modalContent.empty();
    });

    modalContent.empty();

    //removes all modifiers
    modalDialog.attr('class', function(i, className) {
        return className.replace(/\S+--\S+/gm, '');
    });

    // if present applies modifier size class
    if (options.size) modalDialog.addClass(`modal-dialog--${options.size}`);

    // if present applies modifier extra class
    if (options.modalclass) modalDialog.addClass(`modal-dialog--${options.modalclass}`);

    // Set the html each time add to bag is called 
    modalContent.html(modal.data('loadingtext'));

    modalContent.load(options.href, function (e) {
        modal.modal('show');

        var codemodule = $('.pageJS', modalDialog).attr("module");

        if (codemodule) {
            awaitLoad(codemodule,null)
                .then(function (result) {
                    window[codemodule].init.bind(window)();
                    modal.one('hidden.bs.modal', function () {
                        window[codemodule].exit.bind(window)();
                    });
                });
        }

        // user integration, dont worry
        if (cb) {
            cb(e);
        }
    });
}